import styled, { css } from 'styled-components';
import { Tag } from 'components/atoms/tag';

const LightActiveStateStyle = css`
  background: var(--cp-selected-default-gray);
  outline-color: transparent;
`;
const DarkActiveStateStyle = css`
  background: var(--cp-selected-default-gray-inverse);
  outline-color: transparent;
`;
const LightDefaultStateStyle = css`
  outline-color: var(--cp-background-as-black-opacity);
`;
const DarkDefaultStateStyle = css`
  outline-color: var(--cp-white-opacity-20-hover);
`;

export const CpTag = styled(Tag).attrs<{ active?: boolean }>({
  className: 'cp-body-00-primary',
})<{ active?: boolean; autoAdjustColor?: boolean }>`
  padding: var(--cp-spacing-03) var(--cp-spacing-05);
  color: var(--cp-body-00-primary);
  ${(props) =>
    props.autoAdjustColor
      ? css`
          .cp-dark-background & {
            color: var(--cp-text-primary-inverse);
          }
        `
      : css``};
  cursor: pointer;
  font-size: var(--cp-body-00-font-size) !important;
  background: transparent;
  border: none;
  outline-offset: -2px;
  outline: 2px solid;
  :hover {
    background: var(--cp-background-as-black-opacity);
    outline-color: transparent;
  }

  ${(props) =>
    props.active
      ? css`
          ${LightActiveStateStyle};
          ${props.autoAdjustColor
            ? css`
                .cp-dark-background & {
                  ${DarkActiveStateStyle};
                }
              `
            : ''};
        `
      : css`
          ${LightDefaultStateStyle};
          ${props.autoAdjustColor
            ? css`
                .cp-dark-background & {
                  ${DarkDefaultStateStyle};
                }
              `
            : ''}
        `};

  ${(props) =>
    props?.autoAdjustColor
      ? css`
          .cp-dark-background &:hover {
            background: var(--cp-selected-default-gray-inverse);
          }
        `
      : ''};
  display: flex;
  align-items: center;
  justify-content: center;
  gap: var(--cp-spacing-03);
`;

export const CpColorTag = styled(Tag).attrs<{ active?: boolean }>({
  className: 'cp-body-00-primary',
})<{ active?: boolean; autoAdjustColor?: boolean }>`
  padding: var(--cp-spacing-03) var(--cp-spacing-05);

  cursor: pointer;
  font-size: var(--cp-body-00-font-size) !important;
  border: none;

  display: flex;
  align-items: center;
  justify-content: center;
  gap: var(--cp-spacing-03);
`;
